import { render, staticRenderFns } from "./Distro.vue?vue&type=template&id=777affa3"
import script from "./Distro.vue?vue&type=script&lang=js"
export * from "./Distro.vue?vue&type=script&lang=js"
import style0 from "./Distro.vue?vue&type=style&index=0&id=777affa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports